import { TextField } from '@mui/material';

export type FirstNameInputProps = {
  value: string;
  onChange: (value: string) => void;
  label: string;
};

export function FirstNameInput({
  value,
  onChange,
  label,
}: FirstNameInputProps) {
  return (
    <TextField
      type='text'
      label={label}
      size='small'
      fullWidth
      required
      value={value}
      onChange={event => onChange(event.target.value)}
    />
  );
}
